/** Route error boundary (OutlierOS error.tsx): one page crashing never blanks the whole app. */
import { Component, type ReactNode } from 'react';
import { ErrorState } from './primitives';

export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string; supportEmail?: string; onError?: (e: Error) => void }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  override componentDidCatch(error: Error) {
    this.props.onError?.(error);
  }
  override componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }
  override render() {
    if (this.state.error) {
      return <ErrorState onRetry={() => this.setState({ error: null })} homeHref="/" reference={this.state.error.name} supportEmail={this.props.supportEmail} />;
    }
    return this.props.children;
  }
}
